<template>
  <div class="body">
    <!-- 不良汇总 -->
    <baseBreadcrumb :page="$t('message.summaryOfBadPerformanc')" :menu="$t('message.problemSolving')" />
    <div class="body">
      <div class="header">
        <!-- 状态筛选 -->
        <div class="tabs">
          <el-tabs v-model="datas.status" @tab-click="handleClick" type="card">
            <!-- 全部 -->
            <el-tab-pane :label="$t('message.all')" name="0"></el-tab-pane><!-- 检品完了待确认不良   -->
            <el-tab-pane :label="$t('message.problemToBeConfirmed') + `(${tabs[1].num})`" name="1"></el-tab-pane>
            <!--临时检品待确认不良-->
            <el-tab-pane :label="$t('message.theTemporaryInspectionIsDefective') + `(${tabs[2].num})`"
              name="2"></el-tab-pane>
            <!--问题已确认-->
            <el-tab-pane :label="$t('message.problemConfirmed')" name="3"></el-tab-pane>
          </el-tabs>
        </div>
        <!-- 搜索 -->
        <div class="search">
          <!-- 筛选和不良核查共用一个不良ID输入框，回车沿用不良核查。 -->
          <div class="item">
            <el-input v-model.trim="datas.bad_id" :placeholder="$t('message.pleaseEnterBadId')" clearable
              onfocus="this.select()" @keyup.enter.native="searchBadId"></el-input>
          </div>
          <!-- 物流号 -->
          <div class="item">
            <el-input v-model="datas.express_no" :placeholder="$t('message.pleaseEnterTheLogisticsNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 交易号 -->
          <div class="item">
            <el-input v-model="datas.purchase_no" :placeholder="$t('message.pleaseEnterTransactionNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 订单号 -->
          <div class="item">
            <el-input v-model="datas.order_sn" :placeholder="$t('message.orderNumber')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 客户ID -->
          <div class="item">
            <el-input v-model="datas.user_id" :placeholder="$t('message.userID')" clearable
              onfocus="this.select()"></el-input>
          </div>
          <!-- 配货 -->
          <div class="item">
            <el-select v-model="datas.pAdminRealname" clearable filterable
              :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.realname">
              </el-option>
            </el-select>
          </div>
          <!-- 配货 -->
          <div class="item">
            <el-select v-model="datas.pAdminRealname" clearable filterable
              :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.realname">
              </el-option>
            </el-select>
          </div>
          <!-- 配货 -->
          <div class="item">
            <el-select v-model="datas.pAdminRealname" clearable filterable
              :placeholder="$t('message.distributionMember')">
              <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.realname">
              </el-option>
            </el-select>
          </div>
          <!-- 操作跟随筛选项自动换行，不再占用页签右侧。 -->
          <div class="filter-actions">
            <el-button type="primary" @click="handleClick">{{ $t("message.filter") }}</el-button>
            <el-button type="primary" @click="searchBadId">{{ $t('message.badInspection') }}</el-button>
          </div>

          <!-- 业务操作放在筛选栏内，跟随换行并靠最右侧。 -->
          <div class="btn">
            <!-- 问题已确认 -->
            <el-button type="primary" class="primary" @click="badConfirm" v-if="isAuth(210)">{{
              $t("message.problemConfirmed") }}</el-button>
            <!-- 提出问题产品 -->
            <el-button type="primary" class="primary" @click="problemStore" v-if="isAuth(171)">{{
              $t("message.askAQuestionAboutTheProduct") }}</el-button>
          </div>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <!-- 选择 -->
          <li class="flex05"><el-checkbox v-model="checked" @change="allChed">{{ $t("message.allChecked") }}
            </el-checkbox></li>
          <!--  订单号-->
          <li class="flex2">
            {{ $t("message.orderNumber") }}
          </li>
          <!-- 番号-->
          <li class="flex05">
            {{ $t("message.mash") }}
          </li>
          <!-- 照片-->
          <li>
            {{ $t("message.pic") }}
          </li>
          <!-- 商品属性 -->
          <li class="flex15">
            {{ $t("message.theBusinessEditsTheCommodityProperties") }}
          </li>
          <!--应检品数  -->
          <li>{{ $t("message.numberOfProductsToBeInspected") }}</li>
          <!-- 价格-->
          <li class="flex05">
            {{ $t("message.price") }}
          </li>
          <!--待处理附加服务数量  -->
          <li class="flex2">待处理附加服务数量</li>
          <!--交易号  -->
          <li class="flex15">{{ $t("message.transactionNumber") }}</li>
          <!-- 物流号 -->
          <li class="flex15">{{ $t("message.logisticsNumber") }}</li>
          <!--普检/精检问题数  -->
          <li>{{ $t("message.numberOfGeneralTestprecisionTestProblems") }}</li>
          <!-- 布标问题数 -->
          <li>{{ $t("message.numberOfLabelLayoutProblems") }}</li>
          <!-- 商品备注 -->
          <li>{{ $t("message.commodityNote") }}</li>
          <!--状态 -->
          <li>{{ $t("message.status") }}</li>
          <!-- 操作 -->
          <li>操作</li>
        </ol>
        <!-- 无数据显示 -->
        <div class="noData" v-if="tableData == false">暂无数据</div>
        <!-- 订单详情 -->
        <div class="itemDetail" v-for="(item, index) in tableData" :key="index">
          <div class="head">
            <div class="item checkbox">
              <el-checkbox v-model="item.checked" @change="checkedAll(index)"></el-checkbox>
            </div>
            <!-- 是否显示 -->
            <!-- <div class="show" @click="isShow(index)">
              <i class="el-icon-arrow-down" v-if="!item.show"></i>
              <i class="el-icon-arrow-up" v-else></i>
            </div> -->

            <!--  提出时间 -->
            <div class="item time">
              <p>{{ $t("message.forwardTime") }} : {{ item.submit_at }}</p>
            </div>
            <div class="item name">
              <!-- 检品员 -->
              <span>{{ $t("message.inspector") }}：{{
                item.j_admin != null ? item.j_admin.realname : ''
              }}</span>
            </div>
            <!-- 检品单  -->
            <div class="item">
              <span>
                {{ $t("message.CheckList") }}：
                <a href="javascript:;"> {{ item.inspect_sn }}</a>
              </span>
            </div>
          </div>
          <!--  -->
          <ul v-for="(items, indexs) in item.list" :key="indexs" v-show="item.show">
            <!-- 选择 -->
            <li class="flex05">
              <label>
                <el-checkbox v-model="items.checked" @change="changeItem(index)"></el-checkbox>
              </label>
            </li>
            <!--  订单号-->
            <li class="flex2">
              <div>
                <p>{{ items.order_detail.order_sn }}</p>
                <p>{{ items.user != null ? items.user.realname : '' }}</p>
              </div>
            </li>
            <!-- 番号-->
            <li class="flex05">
              {{ items.order_detail.sorting }}
            </li>
            <!--照片-->
            <li>
              <div>
                <div class="img">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="items.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                    <a :href="`https://detail.1688.com/offer/${items.order_detail.goods_id}.html`" target="_blank"
                      slot="reference">
                      <img :src="items.order_detail.pic" alt="" />
                    </a>
                  </el-popover>
                </div>
              </div>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="template">
                <p v-for="(skuItem, skuIndex) in items.order_detail.detail_y" :key="skuIndex">
                  <span>{{ skuItem.key }}:</span>
                  <span>{{ skuItem.value }}</span>
                </p>
              </div>
            </li>
            <!--应检品数  -->
            <li>
              {{ items.num }}
            </li>
            <!-- 价格-->
            <li class="flex05">
              {{ items.order_detail.confirm_price }}
            </li>
            <!--待处理附加服务数量  -->
            <li class="flex2">
              <div class="template">
                <el-tooltip placement="bottom" style="height:100px ;overflow: hidden;">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in items.order_detail.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }} * {{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                  <div style="height: 80px">
                    <div class="row" v-for="(opti, optiIndex) in items.order_detail.option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span v-if="opti.price_type != 1">{{ opti.num }}*{{ opti.price }}元</span>
                        <span v-else> {{ opti.price }}% </span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 交易号  -->
            <li class="flex15">
              {{ items.purchase_no }}
            </li>

            <!-- 物流号 -->
            <li class="flex15">
              <div class="template">
                <p v-for="(wulliu, wulliuIndex) in items.order_purchase_express" :key="wulliuIndex">
                  WL{{ wulliuIndex + 1 }}:{{ wulliu.express_no }}
                </p>
              </div>
            </li>
            <!--普检/精检问题数  -->
            <li>
              <div class="template">
                <!--  实检数 -->
                <p>{{ $t("message.checkNumber") }}:{{ items.inspect_num }}</p>
                <!--  数量差： -->
                <p>
                  {{ $t("message.poorQuantity") }}:{{
                    items.inspect_num - items.num
                  }}

                </p>
                <!--  不良数 -->
                <p>
                  {{ $t("message.adverseNumber") }}:{{ items.inspect_bad_num }}
                </p>
              </div>
            </li>
            <!-- 布标问题数 -->
            <li>
              <div class="template">
                <!--  实检数 -->
                <p>{{ $t("message.checkNumber") }}:{{ items.label_num }}</p>
                <!--  数量差： -->
                <p>
                  {{ $t("message.poorQuantity") }}:

                  {{
                    item.label_admin != null ? items.label_num - items.num : 0
                  }}
                </p>
                <!--  不良数 -->
                <p>
                  {{ $t("message.adverseNumber") }}:{{ items.label_bad_num }}
                </p>
              </div>
            </li>
            <!-- 商品备注 -->
            <li>
              <el-button size="small" type="primary" class="primary" @click="lookRemark(items.order_detail)">
                {{ $t("message.look") }}
              </el-button>
            </li>
            <!--状态 -->
            <li>
              <div>
                <p>{{ items.status_name }}</p>
                <el-tag size="mini" :type="items.is_print === 1 ? 'success' : 'info'">
                  {{ items.is_print === 1 ? $t('message.printed') : $t('message.notPrinted') }}
                </el-tag>
              </div>
            </li>
            <!-- 不良唛头打印，已确认状态也可操作 -->
            <li>
              <el-button size="small" type="primary" @click="printBadMark(item, items)" v-if="items.bad_mark_code">打印</el-button>
            </li>
          </ul>
        </div>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[50, 80, 100, 200]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 商品备注 -->
    <commodityNote v-if="commodityNoteDialogVisible" :commodityNoteData="commodityNoteData" />
    <!-- 问题产品 -->
    <problemStore />
    <!-- 不良码核查及问题产品预提出，沿用核查界面的组件。 -->
    <badInspection ref="badInspection" @confirmed="refreshBadList" />
    <!-- 不良唛头打印 -->
    <badMarkLabel ref="badMarkLabel" />
  </div>
</template>
<script>
import commodityNote from "@/components/common/commodityNote";
import problemStore from "@/components/problemStore/store/index.vue";
import badMarkLabel from "./components/badMarkLabel.vue";
import badInspection from '@/views/home/inspection/commodityInspection/components/badInspection.vue'
export default {
  components: { commodityNote, problemStore, badMarkLabel, badInspection },
  data() {
    return {
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 },],
      datas: {
        status: "1",
        bad_id: "",
        purchase_no: "",
        express_no: "",
        order_sn: "",
        user_id: "",
        page: 1,
        pageSize: 50,
      },
      total: 0,
      tableData: [],
      commodityNoteData: {},
      commodityNoteDialogVisible: false,
      checked: false,//全选
    };
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    this.badList();
    this.badListNum()
  },
  methods: {
    // 允许输入纯 ID 或扫描 BL- 前缀的不良码，接口只接收 ID。
    searchBadId() {
      const badId = String(this.datas.bad_id || '').trim().replace(/^BL-?/i, '').trim()
      if (!badId) return this.$message.error(this.$t('message.pleaseEnterBadId'))
      this.$refs.badInspection.openById(badId)
    },
    // 弹窗确认后同步刷新汇总列表及页签数量。
    refreshBadList() {
      this.badList()
      this.badListNum()
    },
    badListNum() {
      this.$api.tabTotalApi.badListNum().then(res => {
        this.tabs = res.data
      })
    },
    // 列表
    badList() {
      // 共用输入框允许扫描BL前缀，列表接口同样只提交纯不良ID。
      this.datas.bad_id = String(this.datas.bad_id || '').trim().replace(/^BL-?/i, '').trim()
      this.$api.inspectionApi.badList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          item.show = true;
          item.checked = false;
          item.list.forEach((items) => {
            items.checked = false;
          });
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    // 查看备注
    lookRemark(item) {
      this.commodityNoteData = {
        p_remark: item.p_remark,
        y_remark: item.y_remark,
        g_remark: item.g_remark,
      };
      this.commodityNoteDialogVisible = true;
    },
    // 打印当前不良记录对应的不良唛头
    printBadMark(item, items) {
      if (!items.bad_mark_code) return this.$message.error('暂无不良品编号');
      this.$refs.badMarkLabel.print({
        customer_attribute: items.attribute_name,
        user_name: items.user != null ? items.user.realname + '-' + items.user.id : '',
        bad_id: items.id,
        bad_mark_code: items.bad_mark_code,
        express_no: items.order_purchase_express != false ? items.order_purchase_express[0].express_no : '',
        bad_num: items.inspect_bad_num,
        checker_name: items.p_admin != null ? items.p_admin.realname : '',
        inspector_name: item.j_admin != null ? item.j_admin.realname : '',
        purchaser_name: items.g_admin != null ? items.g_admin.realname : '',
        salesman_name: items.y_admin != null ? items.y_admin.realname : ''
      });
      this.$api.inspectionApi.badMarkPrint({
        inspectBadIds: [items.id]
      }).then(() => {
        items.is_print = 1;
      });
    },
    handleClick() {
      this.datas.page = 1;
      this.badList();
    },
    // 全选
    allChed() {

      this.tableData.forEach(item => {
        item.checked = this.checked
        item.list.forEach(items => {
          items.checked = this.checked
        })
      })
      this.$forceUpdate()
    },
    // 单子全选
    checkedAll(i) {
      this.tableData[i].list.forEach((item) => {
        item.checked = this.tableData[i].checked;
      });
    },
    // 单选
    changeItem(i) {
      this.tableData[i].checked = this.tableData[i].list.every(
        (item) => item.checked
      );
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.badList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.badList();
    },

    // 提出问题产品
    problemStore() {
      let datas = {
        order_purchase_id: [],
        inspect_bad_list: [],
        type: 4
      };
      let order_sn = [];
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            datas.order_purchase_id.push(items.order_purchase_id);
            datas.inspect_bad_list.push({ inspect_bad_id: items.id, num: items.inspect_bad_num })
            order_sn.push(items.order_detail.order_sn);
          }
        });
      });

      //
      if (datas.order_purchase_id == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      order_sn = Array.from(new Set(order_sn));
      // 问题产品提出需要限制单次只能单个订单的商品一起提出问题产品
      if (order_sn.length > 1)
        return this.$message.error(this.$t("message.danGeDanDingDan"));
      console.log(datas);
      this.$store.dispatch("getProblemList", datas);
    },
    // 问题产品提交成功
    problemStoreSuccess() {
      this.refreshBadList()
      this.$refs.badInspection.close()
    },
    //问题已确认
    badConfirm() {
      let datas = {
        inspectBadIds: [],
      };

      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            datas.inspectBadIds.push(items.id);
          }
        });
      });
      if (datas.inspectBadIds == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      this.$confirm(
        this.$t("message.isProblemConfirmed"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.inspectionApi.badConfirm(datas).then((res) => {
            this.$message.success(res.msg);
            this.badList();
            this.badListNum()
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang='scss' scoped>
.tabs {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 20px;

  .el-tabs {
    flex: 1;
    min-width: 0;
  }
}

.search {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 24px;
  margin: 15px 0 24px;
  position: relative;

  .item {
    flex: 0 0 210px;
    max-width: 100%;

    .el-select {
      width: 100%;
    }
  }

  .filter-actions {
    display: flex;
    gap: 12px;
  }

  .el-button {
    margin-left: 0;
  }
}

// 业务操作跟随筛选项排布，使用剩余空间靠右，避免额外占用整行。
.search > .btn {
  display: flex;
  margin-left: auto;
  max-width: 100%;
  gap: 16px;

  .el-button {
    margin: 0;
  }
}

.noData {
  text-align: center;
  padding: 20px 0;
}

.table {
  ol {
    display: flex;
    margin: 20px 0 0;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 99;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;
    }
  }

  ul {
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .checkbox {
    margin-left: 15px;
  }

  .itemDetail {
    .head {
      height: 60px;

      display: flex;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      a {
        color: #fff;
      }

      .show {
        cursor: pointer;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: 16px;
          margin: 0 48px 0 24px;
        }
      }

      .item {
        line-height: 40px;
        padding: 10px;
        margin-right: 48px;

        span {
          margin-right: 30px;
        }
      }

      .express_no-list {
        width: 20px;
        height: 20px;
        padding: 0;
        margin-left: 10px;

        /deep/.el-popper {
          background-color: pink !important;
        }
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}
</style>
